// extracted by mini-css-extract-plugin
export default {"main":"AnimateOnScroll_main__1jrYf","show":"AnimateOnScroll_show__FlhZJ"};